import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label', 'option']

  submit (event) {
    const accountLabel = event.currentTarget.dataset.accountSwitcherLabel
    if (!accountLabel) return

    this.element.setAttribute('aria-busy', 'true')
    this.labelTarget.textContent = `Switching to ${accountLabel}…`
    this.optionTargets.forEach(option => { option.disabled = true })
  }
}
